/**
 * An error boundary component that wraps an entire React Router route.
 * Renders an unknown error page that can be customized.
 * Reports the error to the error service.
 *
 * See: https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/v7/#set-up-a-custom-error-boundary
 */

import { useServices } from '#src/services/services.ts';
import { UnknownErrorPage } from '#src/ui/error/unknown_error_page.tsx';
import { useEffect } from 'react';
import { useRouteError } from 'react-router';

export const RouteErrorBoundary = () => {
  const error = useRouteError() as Error;
  const { errorService } = useServices();

  useEffect(() => {
    errorService.captureError(error, {
      message: 'An unexpected rendering error occurred.',
    });
  }, [error, errorService]);

  return <UnknownErrorPage />;
};
